import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { Popup } from 'next-common-lib';
import i18n from 'i18n';
import TextFieldFormik from 'components/Common/InputBox';
import TblList from 'components/Common/Template/TblList';
import PopConfirmButton from 'components/Common/Buttons/PopConfirmButton';
import TblCell from 'components/Common/Template/TblCell';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import * as departmentActions from 'redux/ducks/Department/DepartmentDucks';
import departmentSchema from './DepartmentSchema';

export const PopupDepartment = () => {
  const dispatch = useDispatch();
  const isPopup = useSelector(state => state.wizard.isPopup);
  const adminVo = useSelector(state => state.adminInfo.adminVo);
  const isSuccess = useSelector(state => state.department.isSuccess);

  const formik = useFormik({
    initialValues: { deptCd: '', deptNm: '', enDeptNm: '' },
    validationSchema: departmentSchema,
    onSubmit: values => {
      const payload = {
        deptCd: values.deptCd.toUpperCase(),
        deptNm: values.deptNm,
        enDeptNm: values.enDeptNm,
        uprDeptNm: adminVo.compNm,
        enUprDeptNm: adminVo.enCompNm,
        compCd: adminVo.compCd,
        alignNo: 1,
        compNm: adminVo.compNm,
        enCompNm: adminVo.enCompNm,
        lowDeptExistYn: 'F', // 하위부서존재여부
        orgLvl: 1,
        prefLangCd: adminVo.locale,
        uprDeptCd: 'TOP',
      };
      dispatch(departmentActions.createDepartment(payload));
    },
  });
  const handleOnClose = () => {
    formik.handleReset();
    dispatch(wizardActions.closePopup());
  };

  useEffect(() => {
    if (isSuccess) {
      handleOnClose();
    }
  }, [isSuccess]);

  return (
    <>
      {isPopup && (
        <Popup
          id="departmentPopup"
          isShow={isPopup}
          isDimed={isPopup}
          dimedClassName="transparent"
          isDimedOverlap
          zIndex={2500}
          size="sm w-popup"
          useScroll={false}
          heiht="400px"
          componentType="normalPopup"
          closeFunction={() => {
            handleOnClose();
          }}
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t('BTY_W_T_DEPT_ADD')}
            </h1>,
          ]}
          contentsComponent={[
            <div className="article-body">
              <TblList>
                <TblCell isHeader>{i18n.t('MB_T_DEPT_DEPTCODE')}</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="deptCd"
                    formik={formik}
                    placeholderLabel={i18n.t('MB_M_DEPT_JS_ENTERDEPTCODE')}
                    maxLength={20}
                    useExpLabel={formik.errors.deptCd !== undefined}
                    autoFocus
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader>{i18n.t('MB_T_DEPT_DEPTNAME')}</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="deptNm"
                    formik={formik}
                    maxLength={30}
                    useExpLabel={formik.errors.deptNm !== undefined}
                    placeholderLabel={i18n.t('MB_M_MANAGER_JS_ENTERDEPT')}
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader>{i18n.t('MB_T_DEPT_DEPTNAME_EN')}</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="enDeptNm"
                    formik={formik}
                    maxLength={30}
                    useExpLabel={formik.errors.enDeptNm !== undefined}
                    placeholderLabel={i18n.t('MB_M_DEPT_JS_ENGLISHDEPTNAME')}
                  />
                </TblCell>
              </TblList>
            </div>,
          ]}
          bottomComponent={[<PopConfirmButton confirmAction={formik.submitForm} cancelAction={handleOnClose} />]}
        />
      )}
    </>
  );
};
PopupDepartment.propTypes = {};
PopupDepartment.defaultProps = {};
export default PopupDepartment;
